import type { ItemsByTypeAndId } from '../../types';
import { prop } from '../prop';

export function getTaskData(uuid: string, itemsByTypeAndId: ItemsByTypeAndId, singleUserVersion: boolean) {
  const tasksById = prop(itemsByTypeAndId, 'tasks');
  const task = tasksById[uuid];
  const functionsById = prop(itemsByTypeAndId, 'functions');
  const fId = task.functionUuid;
  if (fId === undefined) throw new Error('Illegal state (E910), no parent reference ' + JSON.stringify(task));
  const parent = functionsById[fId];
  let responsible;
  if (task.responsibleFunctionUuid) {
    responsible = functionsById[task.responsibleFunctionUuid];
  }
  let target;
  const name = task.name;
  const startTask = task.locked;
  if (startTask) {
    target = uuid;
  } else if (!singleUserVersion) {
    target = parent.pages[0] + '/functions/' + parent.uuid + '/tasks/' + uuid;
  } else if (task.pages && task.pages.length > 0) {
    target = task.pages[0] + '/tasks/' + uuid;
  } else if (parent.type !== 'COMMON') {
    target = parent.pages[0] + '/tasks/' + uuid;
  } else if (responsible) {
    target = responsible.pages[0] + '/tasks/' + uuid;
  } else {
    target = '357' + '/tasks/' + uuid;
  }
  return { target: target, startTask: startTask, name: name };
}
